const div = document.createElement('div')
div.className = 'blue-div';
const questions = document.querySelectorAll(".question")
const reponses = document.querySelectorAll(".reponse")

for (var i = 0; i < questions.length; i++) {
  questions[i].addEventListener("click", function(e) {
   var current = this;
   for (var i = 0; i < questions.length; i++) {
    if (current != questions[i]) {
      questions[i].classList.remove('question-active');
      reponses[i].classList.add('hide')

    } else if (current.classList.contains('question-active') === true) {
      current.classList.remove('question-active');
      reponses[i].classList.add('hide')
      const blueDiv = questions[i].querySelector('.blue-div')
      questions[i].removeChild(blueDiv)

    } else {
      current.classList.add('question-active')
      questions[i].appendChild(div)
      reponses[i].classList.remove('hide')
    }
  }
})
}
